<router>
{
    name: 'Analytics Settings',
}
</router>

<template lang="pug">
v-container(light)
    v-row
        v-col(cols="12")
            SystemsSettings(
                :systems="localSystems",
                :customerId="customerId",
                :uom="uom",
                @update:systems="handleUpdateSystems",
                @save:systems="handleSaveSystems",
                @refresh="fetchConfig",
                @create:model="handleCreateModel",
                @show-snackbar="$root.$emit('show:alert', $event)"
            )

</template>

<script lang="js">

import mergeDeep from 'lodash/merge';
import SystemsSettings from '@/components/portal/analytics/Systems';

import { mapActions, mapGetters } from 'vuex';
import dashboard from '@/components/dashboard.vue';

export default {
    name: 'AnalyticsSettings',
    extends: dashboard,
    components: {
        SystemsSettings,
    },
    data () {
        return {
            selectedSystem: null,
            localSystems: [],
            uom: [],
            customerId: 0,
        };
    },
    methods: {
        ...mapActions([
            'fetchAnalyticsConfig',
            'saveAnalyticsConfig',
            'fetchAnalyticsUnitsOfMeasure',
            'updateAnalyticsConfig',
            'createAnalyticsModel',
        ]),

        // Update the systems configuration in the store, be sure to always pass the entire systems array
        handleUpdateSystems (newSystems) {
            this.updateAnalyticsConfig(newSystems);
        },

        async fetchConfig () {
            try {
                await Promise.all([
                    this.fetchAnalyticsConfig(),
                    this.fetchAnalyticsUnitsOfMeasure()
                ]);
                this.$set(this, 'localSystems', mergeDeep([], this.analyticsConfig));
                this.$set(this, 'uom', mergeDeep([], this.analyticsUnitsOfMeasure));
            } catch (error) {
                this.showSnackbar({message: 'Error fetching systems', type: 'error'});
            }
        },

        showSnackbar ({message, type = null}) {
            this.$root.$emit('show:alert', {message, type});
        },

        /**
         * Save the systems configuration to server
         *
         * @param {object[]} newSystems
         */
        async handleSaveSystems (newSystems) {
            try {
                await this.saveAnalyticsConfig(newSystems);

                if(this.error){
                    this.showSnackbar({message: 'Error saving systems', type: 'error'});
                    return;
                }

                await this.fetchConfig();
                if(this.error){
                    this.showSnackbar({message: 'Error fetching systems', type: 'error'});
                    return;
                }

                this.showSnackbar({message: 'Systems saved successfully'});
            } catch (error) {
                this.showSnackbar({message: 'Error saving systems', type: 'error'});
            }
        },

        /**
         *
         * @param {string} systemId
         */
        async handleCreateModel (systemId) {
            console.log('Creating model:', systemId, this.userEmail, '<<');
            await this.createAnalyticsModel({systemId, userEmail: this.userEmail});
            if(this.error){
                this.showSnackbar({message: 'Error creating model', type: 'error'});
                return;
            }
            if(this.taskModelId){
                this.showSnackbar({message: 'Model Creation Queued'});
            }
        },

        openPoints (system) {
            this.$set(this, 'selectedSystem', system);
            this.$set(this, 'uom', this.analyticsUnitsOfMeasure);
            this.$set(this, 'canViewPoints', true);
        },

        downloadingClient (bool) {
            this.isDownloadingClient = bool;
        }
    },
    watch: {
        customerId: {
            handler (newVal) {
                this.fetchConfig();
                this.canViewPoints = false;
            },
            immediate: true
        }
    },
    computed: {
        ...mapGetters([
            'error',
            'errorMessage',
            'analyticsUnitsOfMeasure',
            'analyticsConfig',
            'taskModelId',
            'userEmail'
        ]),
    },
    created () {
        this.$store.dispatch('connectSocket');
        this.fetchConfig();
    },
    mounted () {
        window.settings = this;
    }
};

</script>
